//  ---------------------------------------------------------------------------
//  DO NOT EDIT THIS FILE! This File was auto-generated.
//  ---------------------------------------------------------------------------
define('root/Assets/Js/Templates',[
	'root/Assets/Templates/Html/AudienceNavigation/Js/AudienceNavigation',
	'root/Assets/Templates/Html/Calendar/Js/Calendar',
	'root/Assets/Templates/Html/Contact/Js/Contact',
	'root/Assets/Templates/Html/FullFooter/Js/FullFooter',
	'root/Assets/Templates/Html/FullHeader/Js/FullHeader',
	'root/Assets/Templates/Html/Grid/Js/Grid',
	'root/Assets/Templates/Html/GridSelection/Js/GridSelection',
	'root/Assets/Templates/Html/HeroAnimation/Js/HeroAnimation',
	'root/Assets/Templates/Html/ImageTexts/Js/ImageTexts',
	'root/Assets/Templates/Html/JobOffers/Js/JobOffers',
	'root/Assets/Templates/Html/Locations/Js/Locations',
	'root/Assets/Templates/Html/MarktpreiseForm/Js/MarktpreiseForm',
	'root/Assets/Templates/Html/MarktpreiseOverview/Js/MarktpreiseOverview'
], function () {
	return arguments;
});

